import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Icon } from 'semantic-ui-react'

import APP, { Feature } from 'app'
import { BASE_URL as searchURL } from 'search'
import System from 'system'
import { CreateBanner } from 'tournaments'
import { ContentColumns } from 'ui'

import Message from '../../components/modals/Message'
import PlayingNow from '../../components/sports/soccer/matches/PlayingNow'
import TournamentList from '../../components/sports/tournaments/TournamentList'
import Wall from '../../components/wall/Wall'

class UserHome extends PureComponent {
  state = {
    hideHelp: false,
  }

  helpMessage = () => {
    const { tournaments } = this.props
    const { hideHelp } = this.state

    if (hideHelp || !tournaments.loaded || tournaments?.data?.length !== 0) {
      return null
    }

    const options = [
      {
        content: 'BUSCAR',
        onClick: () => System.history.push(searchURL),
        primary: true,
      },
    ]

    return (
      <Message
        message={
          <div>
            <div style={{ fontSize: '1.2em' }}>
              No tienes <b>Torneos</b>.
            </div>
            <br />- Puedes <b>seguir torneos</b> para ver sus partidos y posiciones.
            <br />- Puedes <b>seguir instituciones</b> para conocer sus movimientos.
            <br />
            <br />
            Haz clic en el botón&nbsp;
            <Icon
              circular
              color="green"
              inverted
              name="search"
              onClick={() => System.history.push(searchURL)}
              size="small"
            />
            &nbsp;para buscar.
          </div>
        }
        onClose={this.onCloseMessage}
        options={options}
        title="Torneos e Instituciones."
      />
    )
  }

  onCloseMessage = () => this.setState({ hideHelp: true })

  render() {
    const { viewer } = this.props

    return (
      <div className="UserHome">
        {this.helpMessage()}
        <ContentColumns
          columns={[
            <>
              {Feature.isEnabled('ff_tournaments') && (
                <CreateBanner onCreateTournament={() => APP.history.push('tournaments_v2/create')} />
              )}
              <Wall add owner={viewer} type="user" wall />
            </>,
            <>
              <PlayingNow />
              <TournamentList owner={viewer} />
            </>,
          ]}
          source="UserHome"
        />
      </div>
    )
  }
}

UserHome.propTypes = {
  tournaments: PropTypes.object,
  viewer: PropTypes.object,
}

UserHome.defaultProps = {
  tournaments: {},
  viewer: null,
}

export default connect(({ tournaments }) => ({
  tournaments,
}))(UserHome)
